import { createContext, type ReactNode } from 'react';

export interface SecondaryHeaderContextValue {
  setHeader: (node: ReactNode) => void;
  clearHeader: () => void;
}

export const SecondaryHeaderContext = createContext<SecondaryHeaderContextValue>({
  setHeader: () => {},
  clearHeader: () => {},
});
